import { render, staticRenderFns } from "./numberMove.vue?vue&type=template&id=8991a2b8&scoped=true"
import script from "./numberMove.vue?vue&type=script&setup=true&lang=ts"
export * from "./numberMove.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./numberMove.vue?vue&type=style&index=0&id=8991a2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8991a2b8",
  null
  
)

export default component.exports